import { ArticlePage } from "components/content/ArticlePage";
import { Meta } from "components/meta/Meta";
import { TermlyDocument } from "components/termlyDocument/TermlyDocument";
import { FC } from "react";

export type DisclaimerPageProps = {};

export const DisclaimerPage: FC<DisclaimerPageProps> = (props) => {
  return (
    <ArticlePage>
      <Meta pageTitle="Disclaimer" />
      <TermlyDocument type="disclaimer" />
    </ArticlePage>
  );
};
